import React from "react";
import { FormattedMessage } from "react-intl";
import {
  InactiveName,
  Line,
  LineHeader,
  LineList,
  WarningText,
} from "./CategoryLimitsField.styles";
import { categoryLimitsMessages } from "./CategoryLimitsField.messages";
import { ExtraLineViewModel } from "./categoryLimitBlock.viewModel";

interface ExtrasChecklistProps {
  lines: readonly ExtraLineViewModel[];
  describedBy?: string;
  onTick: (extraTicker: string, ticked: boolean) => void;
}

/** A checkbox list in aligned columns, not a table: name, type and price per line. */
export function ExtrasChecklist({ lines, describedBy, onTick }: ExtrasChecklistProps) {
  return (
    <>
      <LineHeader aria-hidden="true">
        <span />
        <span>
          <FormattedMessage {...categoryLimitsMessages.columnExtra} />
        </span>
        <span>
          <FormattedMessage {...categoryLimitsMessages.columnType} />
        </span>
        <span>
          <FormattedMessage {...categoryLimitsMessages.columnPrice} />
        </span>
      </LineHeader>
      <LineList aria-describedby={describedBy}>
        {lines.map(line => (
          <Line key={line.ticker}>
            <input
              type="checkbox"
              className="mt-0"
              id={line.id}
              aria-describedby={`${line.id}-type ${line.id}-price`}
              checked={line.checked}
              disabled={line.inactive}
              onChange={event => onTick(line.ticker, event.target.checked)}
            />
            <span>
              <label htmlFor={line.id} className="mb-0">
                {line.inactive ? <InactiveName>{line.name}</InactiveName> : line.name}
              </label>
              {line.inactive && (
                <span className="badge badge-secondary ml-2">
                  <FormattedMessage {...categoryLimitsMessages.inactive} />
                </span>
              )}
            </span>
            <span id={`${line.id}-type`}>{line.unitType}</span>
            <span id={`${line.id}-price`}>{line.price}</span>
            {line.warning && <WarningText>{line.warning}</WarningText>}
          </Line>
        ))}
      </LineList>
    </>
  );
}
